<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                  
                <div class="row mb-5">
                    <div class="col-lg-3">
                        <profile-side-nav />
                    </div>
                    <div class="col-lg-9 mt-lg-0 mt-4">
                        <profile-detail />
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import ProfileSideNav from "./components/ProfileSideNav.vue"
import ProfileDetail from "./components/ProfileDetail.vue"

export default {
    name: 'Profile_index_page',
    components: {
        ProfileSideNav,
        ProfileDetail
    },
    data() {
        return {
            Id: '',
            user: [],
            gets: []
        }
    },
    async mounted() {
        
    },
}
</script>